
<transition appear name="modal">
  <aside v-if="state.isVisible" :class="classes" :id="processID">
    <div class="modal-wrapper" @mousedown="outsideStartClick" @mouseup="outsideClick" ref="modalWrapper">
      <div class="modal-container">
        <div class="modal-body px-4">
          <button v-if="isShouldCancelOnX" type="button" @click.prevent.self="hide($event)" class="btn-icon grey-to-red close close-modal" :class="closeBtnSize">
            <span class="sr-only">Dismiss Modal</span>
            <icon class="times"></icon>
          </button>

          <slot></slot>
          <transition name="fade-in-out" mode="out-in">
            <div v-if="isInStatus(ModalStatus.None)" :key="ModalStatus.None">
              <slot name="body"></slot>
            </div>
            <div v-if="isInStatus(ModalStatus.Confirmation)" :key="ModalStatus.Confirmation">
              <slot :name="ModalStatus.Confirmation">
                Confirmation
              </slot>
            </div>
            <div v-if="isInStatus(ModalStatus.InProgress)" :key="ModalStatus.InProgress">
              <div class="spinner">
                <img src="@assets/images/_icon-spinner.svg" alt="Loading Spinner">
                <slot :name="ModalStatus.InProgress">
                  In Progress
                </slot>
              </div>
            </div>
            <div v-if="isInStatus(ModalStatus.Successful)" :key="ModalStatus.Successful">
              <slot :name="ModalStatus.Successful">
                Successful
              </slot>
            </div>
            <div v-if="isInStatus(ModalStatus.Failure)" :key="ModalStatus.Failure">
              <slot :name="ModalStatus.Failure">
                Failed
              </slot>
            </div>
            <template v-for="status in customStatuses">
              <div v-if="isInStatus(status)" :key="status">
                <slot :name="status" />
              </div>
            </template>
          </transition>
        </div>
      </div>
    </div>
  </aside>
</transition>
